import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import Chart from 'react-apexcharts';
import { Center, Spinner } from '@chakra-ui/react';

const BugsSeverity = ({ data, loading }) => {

  const severityObj = data?.bugsBySeverity || {};

  const allowedDataFromApi = ['High', 'Medium', 'Low'];

  const filteredSeverity = Object.fromEntries(
    Object.entries(severityObj).filter(([key]) =>
      allowedDataFromApi.includes(key)
    )
  );

  const categories = Object.keys(filteredSeverity);
  const values = Object.values(filteredSeverity);

    const series = [
    {
      name: 'Bugs',
      data: values,
    },
  ];

  if (loading) {
    return (
      <Center h="200px">
        <Spinner />
      </Center>
    );
  }

  const options = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 600,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 2,
        columnWidth: '50%',
        distributed: true,
        dataLabels: {
          position: 'top',
        },
      },
    },
    colors: ['#EF4444', '#F59E0B', '#10B981'],
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val} (${((val / 90) * 100).toFixed(1)}%)`,
      offsetY: -20,
      style: {
        fontSize: '11px',
        fontWeight: '600',
        colors: ['#4B5563'],
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: '12px',
          fontWeight: 500,
          colors: '#6B7280',
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '11px',
          colors: '#9CA3AF',
        },
      },
      title: {
        text: '',
      },
    },
    grid: {
      show: true,
      borderColor: '#F3F4F6',
      strokeDashArray: 3,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
      padding: { top: 0, right: 10, bottom: 0, left: 10 },
    },
    legend: { show: false },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value) => `${value} bugs`,
      },
    },
  };

  return (
    <>
      <VStack align="stretch" spacing={2}>
        <Text fontSize="md" fontWeight="semibold" mb={0}>
          Bugs By Severity
        </Text>
        <Box
          bg="white"
          borderRadius="lg"
          p={6}
          boxShadow="sm"
          borderWidth="1px"
          borderColor="gray.200"
          h="310px"
        >
          <Chart options={options} series={series} type="bar" height={260} />
        </Box>
      </VStack>
    </>
  );
};

export default BugsSeverity;
